import type { FaireProductEntity } from "../../entity_types/product";

export const p_hf723xpyq8: FaireProductEntity = {
  token: "p_hf723xpyq8",
  type: "product",
  name: "Labyrinth Acacia Wood",
  brandToken: "b_fpfqb8hgs8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/6e795409ccb61f57eb3222ee85bc5c40cc272e85538d3ba4bd5cd19c876a86b1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a988e1ec22cc24b8a95fbfb37d1d88071714f28fa8b8cd615a93d719a77460e.png",
    "https://cdn.faire.com/fastly/f95e57e0367acb8efa8edc7f097fbe4d95312ce95383db0f092f9e170cd20ca4.png",
    "https://cdn.faire.com/fastly/83d9193cf12827bdd494857be54f10b66980c18a7f9af9b495e1bfb89b773dd0.png",
    "https://cdn.faire.com/fastly/75110ae6711a84e96ee0d1af22ec034031d6f06135813f508c9f77a3a8eb28f9.png",
    "https://cdn.faire.com/fastly/72efddda8181ca46f6360620e0328c81e9811345e836ff424b480beaf5676d27.png",
    "https://cdn.faire.com/fastly/186e7a32cd3f69ffa5f6140ff3896c75a24823e50639d432e853d73362be93f8.png",
  ],
  priceDollars: 13,
  description:
    'A beautifully crafted acacia wood labyrinth designed for mindfulness, calm, and everyday reflection.\n\nHand carved acacia wood maze with metal balls. \nSize: 1"h x 5"w 4"d\nHandmade in India by artisans at out Fair Trade partner.\nWARNING - Choking Hazard. Not intended for children under 3 yrs\n',
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:48.931Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
